import { AutoComplete, IAutoComplete } from 'src/app/features/shared/controls/models/auto-complete.model';

// Type van een rol, afgeleid uit Role.DomainAssignable (de DB kent geen eigen type-kolom):
//   admin role  (false) — alleen in AdminPanel aan functies te koppelen;
//   domain role (true)  — ook aan domein-eigen functies (Domain › Function › tab roles).
// Rollen worden alleen in AdminPanel aangemaakt en ingesteld; FunctionController.Update laat in een
// gebruikersdomein alleen domain roles erbij/eraf (escalatiebeveiliging).
export const roleType = {
    admin: 'admin',
    domain: 'domain',
} as const;

export type TRoleType = (typeof roleType)[keyof typeof roleType];

export const roleTypeLabel: Record<TRoleType, string> = {
    [roleType.admin]: 'admin role',
    [roleType.domain]: 'domain role',
};

export const roleTypeList: IAutoComplete[] = [
    AutoComplete.create(roleType.admin, roleTypeLabel[roleType.admin])!,
    AutoComplete.create(roleType.domain, roleTypeLabel[roleType.domain])!,
];

export function roleType_get(domainAssignable: boolean | null | undefined): TRoleType {
    return domainAssignable ? roleType.domain : roleType.admin;
}

// Label voor lijsten/compact: werkt op RoleData én RoleListData (zelfde sleutel domainAssignable).
export function roleTypeLabel_get(item: { domainAssignable?: boolean | null } | null | undefined): string {
    return roleTypeLabel[roleType_get(item?.domainAssignable)];
}
